/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Delete_Account_DescInputs */

const en_settings_delete_account_desc = /** @type {(inputs: Settings_Delete_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All your data will be permanently deleted within 30 days.`)
};

const de_settings_delete_account_desc = /** @type {(inputs: Settings_Delete_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Ihre Daten werden innerhalb von 30 Tagen unwiderruflich geloescht.`)
};

const fr_settings_delete_account_desc = /** @type {(inputs: Settings_Delete_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes vos donnees seront definitivement supprimees dans les 30 jours.`)
};

const es_settings_delete_account_desc = /** @type {(inputs: Settings_Delete_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos tus datos seran eliminados permanentemente en un plazo de 30 dias.`)
};

const it_settings_delete_account_desc = /** @type {(inputs: Settings_Delete_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i tuoi dati verranno eliminati permanentemente entro 30 giorni.`)
};

const nl_settings_delete_account_desc = /** @type {(inputs: Settings_Delete_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al uw gegevens worden permanent verwijderd binnen 30 dagen.`)
};

const pl_settings_delete_account_desc = /** @type {(inputs: Settings_Delete_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie Twoje dane zostana trwale usuniete w ciagu 30 dni.`)
};

const fi_settings_delete_account_desc = /** @type {(inputs: Settings_Delete_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki tietosi poistetaan pysyvästi 30 päivän kuluessa.`)
};

const da_settings_delete_account_desc = /** @type {(inputs: Settings_Delete_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle dine data slettes permanent inden for 30 dage.`)
};

const sv_settings_delete_account_desc = /** @type {(inputs: Settings_Delete_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla dina data kommer att raderas permanent inom 30 dagar.`)
};

/**
* | output |
* | --- |
* | "All your data will be permanently deleted within 30 days." |
*
* @param {Settings_Delete_Account_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_delete_account_desc = /** @type {((inputs?: Settings_Delete_Account_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Delete_Account_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_delete_account_desc(inputs)
	if (locale === "fr") return fr_settings_delete_account_desc(inputs)
	if (locale === "es") return es_settings_delete_account_desc(inputs)
	if (locale === "it") return it_settings_delete_account_desc(inputs)
	if (locale === "nl") return nl_settings_delete_account_desc(inputs)
	if (locale === "pl") return pl_settings_delete_account_desc(inputs)
	if (locale === "fi") return fi_settings_delete_account_desc(inputs)
	if (locale === "da") return da_settings_delete_account_desc(inputs)
	if (locale === "sv") return sv_settings_delete_account_desc(inputs)
	return en_settings_delete_account_desc(inputs)
});